const APP_VERSION_KEY = 'floert-version'

export async function registerSW() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })

      console.log('Service Worker registered successfully')

      // Listen for version update messages from SW
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'VERSION_UPDATED') {
          console.log('App updated to version:', event.data.version)
          // Reload to get new content
          window.location.reload()
        }
      })

      // Check version on startup
      registration.active?.postMessage({ type: 'CHECK_VERSION' })

      // Also check when SW becomes active
      registration.addEventListener('controllerchange', () => {
        console.log('New service worker activated')
      })

    } catch (error) {
      console.error('Service Worker registration failed:', error)
    }
  }
}

export async function checkForUpdates(): Promise<{ hasUpdate: boolean; newVersion?: string }> {
  try {
    const online = navigator.onLine

    if (!online) {
      console.log('Offline - using cached content')
      return { hasUpdate: false }
    }

    const response = await fetch('/version.txt', {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    })

    if (!response.ok) {
      return { hasUpdate: false }
    }

    const serverVersion = (await response.text()).trim()
    const storedVersion = localStorage.getItem(APP_VERSION_KEY)

    if (!storedVersion) {
      // First time - store version
      localStorage.setItem(APP_VERSION_KEY, serverVersion)
      return { hasUpdate: false }
    }

    if (storedVersion !== serverVersion) {
      // Update available
      localStorage.setItem(APP_VERSION_KEY, serverVersion)
      return { hasUpdate: true, newVersion: serverVersion }
    }

    return { hasUpdate: false }

  } catch (error) {
    console.log('Version check failed - using cached content')
    return { hasUpdate: false }
  }
}

export async function clearCachesAndReload() {
  if ('serviceWorker' in navigator) {
    const controller = navigator.serviceWorker.controller
    if (controller) {
      return new Promise<void>((resolve) => {
        const messageChannel = new MessageChannel()
        messageChannel.port1.onmessage = () => {
          window.location.reload()
          resolve()
        }
        controller.postMessage(
          { type: 'CLEAR_ALL_CACHES' },
          [messageChannel.port2]
        )
      })
    }
  }
}
